import { axiosBase } from '../../api/axios-base';

const state = {
  type_dtp_count: null,
  hist_dtp_in_time: null,
  plot3dtest: null
};

const getters = {
  TYPE_DTP_COUNT: (state) => {
    return state.type_dtp_count
  },
  HIST_DTP_IN_TIME: (state) => {
    return state.hist_dtp_in_time
  },
  PLOT_3D_TEST: (state) => {
    return state.plot3dtest
  }
};

const mutations = {
  SET_type_dtp_count: (state, data) => {
    state.type_dtp_count = data
  },
  SET_hist_dtp_in_time: (state, data) => {
    state.hist_dtp_in_time = data
  },
  SET_plot3dtest: (state, data) => {
    state.plot3dtest = data
  }
};

const actions = {
  GET_TYPE_DTP_COUNT: async (context) => {
    let { data } = await axiosBase.get("/analytics/type_dtp_count/");
    context.commit("SET_type_dtp_count", data)
  },
  GET_HIST_DTP_IN_TIME: async (context) => {
    let { data } = await axiosBase.get("/analytics/hist_dtp_in_time/");
    context.commit("SET_hist_dtp_in_time", data)
  },
  GET_PLOT_3D_TEST: async (context) => {
    let { data } = await axiosBase.get("/analytics/plot3dtest/");
    context.commit("SET_plot3dtest", data)
  },
  GET_FILTERED_GRAPH: async (context, options) => {
    let { data } = await axiosBase.get("/analytics/" + options.url + '/',{
      params: {
        year: options.year.length === 1 ? options.year.join("") : options.year.join("|"),
        field: options.dtp_type,
      }
    });
    context.commit("SET_" + options.url, data);
  }
};

export default {
  state,
  getters,
  mutations,
  actions,
};
